// @ts-ignore
import StringMask from "string-mask";

const cnpjFormatter = new StringMask("AA.AAA.AAA/AAAA-AA");

export function formatCnpj(cnpj: string) {
  return cnpjFormatter.apply(cnpj);
}
